import { render, staticRenderFns } from "./TokopediaConnectionCard.vue?vue&type=template&id=da1eb18c"
import script from "./TokopediaConnectionCard.vue?vue&type=script&lang=js"
export * from "./TokopediaConnectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports